export const additionalIgnoreSelectors = [
  '#signly-button',
  '#signly-border',
  '#signly-playing-border',
  '[data-v-app]',
  '.signly-drop-zone.left',
  '.signly-drop-zone.right'
]
